const parseFrenchDate = (dateStr) => {
  if (!dateStr) return null;

  const [day, month, year] = dateStr.split("-").map(Number);

  if (!day || !month || !year) return null;

  return new Date(year, month - 1, day);
};

export const filterConsommations = ({
  data,
  searchQuery,
  startDate,
  endDate,
  paymentStatusFilter,
}) => {
  let filteredData = data;

  if (searchQuery) {
    filteredData = filteredData.filter((item) => {
      return (
        item.waterBillRefNumber
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        item.firstName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.lastName?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  }

  const start = startDate ? parseFrenchDate(startDate) : null;
  const end = endDate ? parseFrenchDate(endDate) : null;

  filteredData = filteredData.filter((item) => {
    const itemDate = parseFrenchDate(item.selectedDate);

    if (!itemDate) return false;

    if (start && end) return itemDate >= start && itemDate <= end;
    if (start) return itemDate >= start;
    if (end) return itemDate <= end;

    return true;
  });

  if (paymentStatusFilter) {
    filteredData = filteredData.filter(
      (item) => item.paymentStatus === paymentStatusFilter
    );
  }

  return filteredData;
};